import type { ImageDTO } from "@shared/types";
import { ImageCard } from "./ImageCard";
import { Spinner } from "./Spinner";

interface Props {
  images: ImageDTO[];
  loading: boolean;
  showPendingBadge?: boolean;
  onPreview: (img: ImageDTO) => void;
  onRename: (img: ImageDTO) => void;
  onMove: (img: ImageDTO) => void;
  onDelete: (img: ImageDTO) => void;
  onDetails: (img: ImageDTO) => void;
  onUploadClick: () => void;
}

export function ImageGrid({
  images,
  loading,
  showPendingBadge,
  onPreview,
  onRename,
  onMove,
  onDelete,
  onDetails,
  onUploadClick,
}: Props) {
  if (loading && images.length === 0) {
    return (
      <div className="grid place-items-center py-24">
        <Spinner label="Loading images" />
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="glass glass-quiet grid place-items-center rounded-2xl py-24 text-center">
        <div>
          <p className="text-sm font-medium text-zinc-800">No images here</p>
          <p className="mt-1 text-[13px] text-zinc-500">Drop files anywhere on this page, or</p>
          <button
            onClick={onUploadClick}
            className="mt-2 text-[13px] font-medium text-zinc-900 underline decoration-zinc-400 underline-offset-2 transition-colors hover:decoration-zinc-900"
          >
            choose files to upload
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5">
      {images.map((img) => (
        <ImageCard
          key={img.id}
          image={img}
          showPendingBadge={showPendingBadge}
          onPreview={() => onPreview(img)}
          onRename={() => onRename(img)}
          onMove={() => onMove(img)}
          onDelete={() => onDelete(img)}
          onDetails={() => onDetails(img)}
        />
      ))}
    </div>
  );
}
